<template>
    <div :class="phoneClass || 'content-header-wrapper'">
       <div class="header-left pointer"
            v-if="$route.path.indexOf('/',1) >=0 && $route.path!=='/device/gateway'"
            @click="routerBack">
            <img src="../assets/img/btn/back.png" class="icon-back">
           <span class="title">{{title || $route.name}}</span>
       </div>
       <div class="header-left" v-else>
           <span class="title" v-if="$route.path.substr(1)!=='device/gateway' && $route.path.substr(1)!=='device'">{{$t("header."+$route.path.substr(1)) }}</span>
           <div v-else class="btns">
                <span class="title_tab_pitch" @click="toDevice" v-if="$route.path.substr(1)==='device'">{{$t("header.device")}}</span>
                <span class="title_tab" @click="toDevice" v-if="$route.path.substr(1)!=='device'">{{$t("header.device")}}</span>
                <span class="title_tab_pitch" @click="toGateway" v-if="$route.path.substr(1)==='device/gateway'">{{$t("header.gateway")}}</span>
               <span class="title_tab" @click="toGateway" v-if="$route.path.substr(1)!=='device/gateway'">{{$t("header.gateway")}}</span>
           </div>
       </div>
       <div class="header-right">
           <slot></slot>
       </div>
    </div>
</template>
<script>
import Core from 'core/core'
import {refresh} from "core/winSize"
export default {
    data(){
        return {
	        phoneClass: '',
            pathList: []
        }
    },
    props: {
        pageType: String,
        title: String,
    },
    created(){
	    refresh(this,'phoneClass-content-header-wrapper');
	    window.onresize = function(){
		    setTimeout(function(){
			    refresh(this,'phoneClass-content-header-wrapper');
		    },10)
	    };
    },
    mounted() {
        this.initHeader()

    },
    methods: {
        initHeader(){
            let arr = []
            this.pathList = this.$router.options.routes
            this.pathList.map((item) => {
                arr.push(item.path)
            })
            this.pathList = arr
            // console.log(this.$route.path,'path')
            // console.log(arr,'arr')
        },
       routerBack() {
           this.$router.go(-1);
       },
        toDevice(){
            this.$router.push({
                path: '/device'
            })
        },
        toGateway(){
            this.$router.push({
                path: '/device/gateway'
            })
        }
    },
};
</script>
<style lang="scss" scoped>
@import '../assets/style/mixin.scss';
.content-header-wrapper {
    height: 60px;
    background: #0A3D95;
    @include flex-sb;
    padding: 0 40px;
    .header-left {
        &.pointer {
            cursor: pointer;
        }
        .icon-back {
            width: 16px;
            height: 16px;
            margin-right: 6px;
            vertical-align: middle;
        }
        .title {
            vertical-align: middle;
            font-size: 16px;
            color: #FFFFFF;
            font-weight: 500;
        }

        .title_tab {
            padding: 20px;
            vertical-align: middle;
            font-size: 16px;
            color: #fff;
            font-weight: 500;
        }
        .title_tab_pitch {
            padding: 21px;
            vertical-align: middle;
            font-size: 16px;
            color: #0A3D95;
            font-weight: 500;
            background: #fff;
        }
    }
}

.phoneClass-content-header-wrapper {
    min-height: 46px;
    // background: #FFFFFF;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #EEF2F6;
    .header-left {
        margin-left: 15px;
    }
    .icon-back {
        width: 16px;
        height: 16px;
        margin-right: 6px;
        vertical-align: middle;
    }

    .title {
        vertical-align: middle;
        font-size: 20px;
        font-weight: 600;
        color: #353C41;
    }
    .title_tab {
        padding: 6px;
        vertical-align: middle;
        font-size: 16px;
        color: #fff;
        font-weight: 500;
        border-radius: 2px;
    }
    .title_tab_pitch {
        padding: 6px;
        vertical-align: middle;
        font-size: 16px;
        color: #0A3D95;
        font-weight: 500;
        background: #fff;
        border-radius: 2px;
    }
}
</style>